<template>
  <div class="locale-changer">
    <b-form-select v-model="locale" :options="options"></b-form-select>
  </div>
</template>

<script>
export default {
  name: 'locale-changer',
  data () {
    return {
      locale: localStorage.getItem('locale') || 'ru',
      options: [
        { value: 'en', text: this.$i18n.t('English') },
        { value: 'ru', text: this.$i18n.t('Russian') }
      ]
    }
  },
  watch: {
    locale: function (val) {
      this.$root.$i18n.locale = val
      localStorage.setItem('locale', val)
    }
  },
  mounted () {
    localStorage.setItem('locale', this.locale)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/langSwitcher.vue